(function () {
  /* =====================================
     FULL FLAKE KIT BUILDER – BASE
     Safe wrapper so nothing leaks globally
  ===================================== */

  if (!window.fetch) {
    console.warn('Fetch not supported');
    return;
  }

  // =====================================
  // PAGE SCOPE GUARD (BUILDER + CART ONLY)
  // =====================================
  const PATH = window.location.pathname.replace(/\/$/, '');

  const IS_BUILDER_PAGE =
    PATH.startsWith('/products/full-flake-epoxy-floor-kits');
  const IS_CART_PAGE =
    PATH === '/cart' ||
    document.body.classList.contains('template-cart') ||
    document.querySelector('.qsc2-drawer');

  if (!IS_BUILDER_PAGE && !IS_CART_PAGE) {
    return;
  }

  if (window.__EPOXY_KIT_INITIALIZED__) return;
  window.__EPOXY_KIT_INITIALIZED__ = true;

  console.log('✅ Full Flake Kit Builder loaded');

  window.__EPOXY_KIT_STATE__ = {
    sqft: null,
    sqftPrice: 0,
    toolkit: null,
    toolkitPrice: 0,
    upgrades: {},
    upgradesPrice: 0
  };

  /* =====================================
     CONFIG – VARIANT IDS (LOCKED)
  ===================================== */

  const TOOLKIT_CHILD_ITEMS = {
  '52106624631087': [
    { variantId: '57942320283951', quantity: 2, label: '18" Rollers' },
    { variantId: '57535511888175', quantity: 2, label: '9" Rollers' },
    { variantId: '57531183595823', quantity: 1, label: 'Spiked Shoes' },
    { variantId: '57532468330799', quantity: 1, label: '8-12 Notched Squeegee' },
    { variantId: '57532984099119', quantity: 1, label: 'Flat Squeegee' },
    { variantId: '57531812905263', quantity: 1, label: 'Box Mixer' },
    { variantId: '57531901051183', quantity: 1, label: 'Big Ben 18" Roller Frame' },
    { variantId: '57535610519855', quantity: 2, label: '3" Chip Brush' },
    { variantId: '57532332310831', quantity: 1, label: '9" Roller Frame' },
    { variantId: '57533077160239', quantity: 1, label: 'Scraper' },
    { variantId: '57533138403631', quantity: 1, label: 'Painter Pole' }
  ],
  '52106624663855': [
    { variantId: '57942320283951', quantity: 3, label: '18" Rollers' },
    { variantId: '57535511888175', quantity: 2, label: '9" Rollers' },
    { variantId: '57531183595823', quantity: 2, label: 'Spiked Shoes' },
    { variantId: '57532468330799', quantity: 1, label: '8-12 Notched Squeegee' },
    { variantId: '57532984099119', quantity: 1, label: 'Flat Squeegee' },
    { variantId: '57531812905263', quantity: 1, label: 'Box Mixer' },
    { variantId: '57531901051183', quantity: 1, label: 'Big Ben 18" Roller Frame' },
    { variantId: '57535610519855', quantity: 2, label: '3" Chip Brush' },
    { variantId: '57532332310831', quantity: 1, label: '9" Roller Frame' },
    { variantId: '57533077160239', quantity: 1, label: 'Scraper' },
    { variantId: '57533138403631', quantity: 2, label: 'Painter Pole' }
  ],
  '52106624696623': [
    { variantId: '57942320283951', quantity: 6, label: '18" Rollers' },
    { variantId: '57535511888175', quantity: 3, label: '9" Rollers' },
    { variantId: '57531183595823', quantity: 3, label: 'Spiked Shoes' },
    { variantId: '57532468330799', quantity: 1, label: '8-12 Notched Squeegee' },
    { variantId: '57532984099119', quantity: 1, label: 'Flat Squeegee' },
    { variantId: '57531812905263', quantity: 1, label: 'Box Mixer' },
    { variantId: '57531901051183', quantity: 2, label: 'Big Ben 18" Roller Frame' },
    { variantId: '57535610519855', quantity: 6, label: '3" Chip Brush' },
    { variantId: '57532332310831', quantity: 1, label: '9" Roller Frame' },
    { variantId: '57533077160239', quantity: 1, label: 'Scraper' },
    { variantId: '57533138403631', quantity: 3, label: 'Painter Pole' }
  ]
};

  const BUNDLE_VARIANTS = {
    400: 52081159602479,
    600: 52081159635247,
    800: 52081159668015,
    1000: 52081159700783,
    1200: 52081159733551,
    1400: 52081159766319,
    1600: 52081159799087,
    1800: 52081159831855,
    2000: 52081159864623,
    2200: 52081159897391,
    2400: 52081159930159,
    2600: 52081159962927,
    2800: 52081159995695,
    3000: 52081160028463,
    3200: 52081160061231,
    3400: 52081160093999,
    3600: 52081160126767,
    3800: 52081160159535,
    4000: 52081160192303,
    4200: 52081160225071,
    4400: 52081160257839,
    4600: 52081160290607,
    4800: 52081160323375,
    5000: 52081160356143,
    5200: 52081358602543,
    5400: 52081358635311,
    5600: 52081358668079,
    5800: 52081358700847,
    6000: 52081358733615,
    6200: 52081358766383,
    6400: 52081358799151,
    6600: 52081358831919,
    6800: 52081358864687,
    7000: 52081358897455,
    7200: 52081358930223,
    7400: 52081358962991,
    7600: 52081358995759,
    7800: 52081359028527,
    8000: 52081359061295,
    8200: 52081359094063,
    8400: 52081359126831,
    8600: 52081359159599,
    8800: 52081359192367,
    9000: 52081359225135,
    9200: 52081359257903,
    9400: 52081359290671,
    9600: 52081359323439,
    9800: 52081359356207,
    10000: 52081359388975
  };

  const CONFIG = {
    epoxyColors: {
      white: 53501871259951,
      lite_gray: 53501871227183,
      royal_blue: 53501871194415,
      black: 53501871292719,
      medium_gray: 53501871358255,
      tan: 53501871325487
    },

    flakes: {
      wombat:      { 40: 52143638053167 },
      domino:      { 40: 52143640314159 },
      tidal_wave:  { 40: 52143638348079 },
      orbit:       { 40: 52143639232815 },
      cabin_fever: { 40: 52143638544687 },
      nightfall:   { 40: 52143638184239 },
      creekbed:    { 40: 52143638708527 },
      raven:       { 40: 52143639691567 },
      shoreline:   { 40: 52143638872367 },
      outback:     { 40: 52143639036207 },
      coyote:      { 40: 52143637692719 },
      gravel:      { 40: 52143637856559 },
      galaxy:      { 40: 52143637168431 },
      stargazer:   { 40: 52143637365039 },
      basalt:      { 40: 52143636807983 },
      schist:      { 40: 52143636447535 },
      carbon:      { 40: 52143636644143 },
      granite:     { 40: 52143637528879 }
    },

    polyaspartic: {
      clear: { 1: 52143646474543, 2: 52143646507311 }
    },

    upgrades: {
      wb_epoxy_primer:          { id: 56130514813231, type: 'auto' },
      premera_fp_fusion_primer: { id: 45756243968303, type: 'auto' },
      moisture_vapor_barrier:   { id: 50599780286767, type: 'auto' },
      high_wear_urethane_finish:{ id: 50873632817455, type: 'auto' },
      crack_and_joint_paste_gal_kit: { id: 45756361965871, type: 'manual' },
      small_crack_and_joint_paste:   { id: 52413208887599, type: 'manual' },
      fine_anti_slip:                    { id: 45756243214639, type: 'auto' },
      coarse_anti_slip:                  { id: 45756243181871, type: 'auto' },
      premera_easymvb:                   { id: 55542586868015, type: 'auto' }
    },

    toolkits: {
      up_to_400:      52106624631087,
      from_401_to_1200: 52106624663855,
      above_1200:     52106624696623
    }
  };

  /* =====================================
     STEP 4 – SQ FT DETECTION
  ===================================== */

  function parseSqftRange(text) {
    text = text.replace(/\s+/g, ' ').toLowerCase();
    const match = text.match(/(\d+)\s*[-–]\s*(\d+)/);
    if (match) {
      return { min: parseInt(match[1], 10), max: parseInt(match[2], 10) };
    }
    return null;
  }

  function initSqFtListener() {
    const container = document.querySelector('.vb-grid-picker_9CJjMy');
    if (!container) return;

    container.addEventListener('click', function (e) {
      const btn = e.target.closest('.vb-pill');
      if (!btn || !container.contains(btn)) return;

      const title = btn.getAttribute('data-variant-title');
      if (!title || !title.toLowerCase().includes('sqft')) return;

      const range = parseSqftRange(title);
      if (!range) return;

      const price = parseFloat(btn.getAttribute('data-price')) / 100 || 0;

      window.__EPOXY_KIT_STATE__.sqft = {
        label: title,
        min: range.min,
        max: range.max
      };
      window.__EPOXY_KIT_STATE__.sqftPrice = price;

      // reset toolkit
      window.__EPOXY_KIT_STATE__.toolkit = null;
      window.__EPOXY_KIT_STATE__.toolkitPrice = 0;

      recalcTotal();

    });
  }

  setTimeout(initSqFtListener, 300);

  /* =====================================
     STEP 5.1 – SQ FT → KIT QTY TABLE
  ===================================== */

  const SQFT_KIT_TABLE = [
    { max: 400,   epoxy: 1,  flake_boxes: 1,  poly_kits: 3  },
    { max: 600,   epoxy: 2,  flake_boxes: 2,  poly_kits: 5  },
    { max: 800,   epoxy: 2,  flake_boxes: 3,  poly_kits: 6  },
    { max: 1000,  epoxy: 3,  flake_boxes: 3,  poly_kits: 8  },
    { max: 1200,  epoxy: 3,  flake_boxes: 4,  poly_kits: 9  },
    { max: 1400,  epoxy: 4,  flake_boxes: 4,  poly_kits: 11 },
    { max: 1600,  epoxy: 4,  flake_boxes: 5,  poly_kits: 12 },
    { max: 1800,  epoxy: 5,  flake_boxes: 6,  poly_kits: 14 },
    { max: 2000,  epoxy: 5,  flake_boxes: 6,  poly_kits: 15 },
    { max: 2200,  epoxy: 6,  flake_boxes: 7,  poly_kits: 17 },
    { max: 2400,  epoxy: 6,  flake_boxes: 8,  poly_kits: 18 },
    { max: 2600,  epoxy: 7,  flake_boxes: 8,  poly_kits: 20 },
    { max: 2800,  epoxy: 7,  flake_boxes: 9,  poly_kits: 21 },
    { max: 3000,  epoxy: 8,  flake_boxes: 9,  poly_kits: 23 },
    { max: 3200,  epoxy: 8,  flake_boxes: 10, poly_kits: 24 },
    { max: 3400,  epoxy: 9,  flake_boxes: 11, poly_kits: 26 },
    { max: 3600,  epoxy: 9,  flake_boxes: 11, poly_kits: 27 },
    { max: 3800,  epoxy: 10, flake_boxes: 12, poly_kits: 29 },
    { max: 4000,  epoxy: 10, flake_boxes: 13, poly_kits: 30 },
    { max: 4200,  epoxy: 11, flake_boxes: 13, poly_kits: 32 },
    { max: 4400,  epoxy: 11, flake_boxes: 14, poly_kits: 33 },
    { max: 4600,  epoxy: 12, flake_boxes: 14, poly_kits: 35 },
    { max: 4800,  epoxy: 12, flake_boxes: 15, poly_kits: 36 },
    { max: 5000,  epoxy: 13, flake_boxes: 16, poly_kits: 38 },
    { max: 5200,  epoxy: 13, flake_boxes: 16, poly_kits: 39 },
    { max: 5400,  epoxy: 14, flake_boxes: 17, poly_kits: 41 },
    { max: 5600,  epoxy: 14, flake_boxes: 18, poly_kits: 42 },
    { max: 5800,  epoxy: 15, flake_boxes: 18, poly_kits: 44 },
    { max: 6000,  epoxy: 15, flake_boxes: 19, poly_kits: 45 },
    { max: 6200,  epoxy: 16, flake_boxes: 19, poly_kits: 47 },
    { max: 6400,  epoxy: 16, flake_boxes: 20, poly_kits: 48 },
    { max: 6600,  epoxy: 17, flake_boxes: 21, poly_kits: 50 },
    { max: 6800,  epoxy: 17, flake_boxes: 21, poly_kits: 51 },
    { max: 7000,  epoxy: 18, flake_boxes: 22, poly_kits: 53 },
    { max: 7200,  epoxy: 18, flake_boxes: 23, poly_kits: 54 },
    { max: 7400,  epoxy: 19, flake_boxes: 23, poly_kits: 56 },
    { max: 7600,  epoxy: 19, flake_boxes: 24, poly_kits: 57 },
    { max: 7800,  epoxy: 20, flake_boxes: 24, poly_kits: 59 },
    { max: 8000,  epoxy: 20, flake_boxes: 25, poly_kits: 60 },
    { max: 8200,  epoxy: 21, flake_boxes: 26, poly_kits: 62 },
    { max: 8400,  epoxy: 21, flake_boxes: 26, poly_kits: 63 },
    { max: 8600,  epoxy: 22, flake_boxes: 27, poly_kits: 65 },
    { max: 8800,  epoxy: 22, flake_boxes: 28, poly_kits: 66 },
    { max: 9000,  epoxy: 23, flake_boxes: 28, poly_kits: 68 },
    { max: 9200,  epoxy: 23, flake_boxes: 29, poly_kits: 69 },
    { max: 9400,  epoxy: 24, flake_boxes: 29, poly_kits: 71 },
    { max: 9600,  epoxy: 24, flake_boxes: 30, poly_kits: 72 },
    { max: 9800,  epoxy: 25, flake_boxes: 31, poly_kits: 74 },
    { max: 10000, epoxy: 25, flake_boxes: 31, poly_kits: 75 }
  ];

  function getKitForSqft(maxSqft) {
    return SQFT_KIT_TABLE.find(row => maxSqft <= row.max);
  }

  /* =====================================
     STEP 6A – EPOXY COLOR (SINGLE SELECT)
  ===================================== */

  function normalizeColor(str) {
    return str
      .toLowerCase()
      .replace(/grey/g, 'gray')
      .replace(/[^a-z]/g, '_')
      .replace(/_+/g, '_')
      .trim();
  }

  function clearEpoxySwatchSelection(container) {
    container.querySelectorAll('.vb-swatch').forEach(btn => {
      btn.classList.remove('is-active', 'active');
      btn.setAttribute('aria-checked', 'false');
    });
  }

  function initEpoxySwatchListener() {
    const container = document.querySelector('.vb-swatches');
    if (!container) return;

    container.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const swatch = e.target.closest('.vb-swatch');
      if (!swatch || !container.contains(swatch)) return;

      const label =
        swatch.getAttribute('data-label') ||
        swatch.getAttribute('aria-label');
      if (!label) return;

      const colorKey = normalizeColor(label);
      if (!CONFIG.epoxyColors[colorKey]) return;

      clearEpoxySwatchSelection(container);
      swatch.classList.add('is-active');
      swatch.setAttribute('aria-checked', 'true');

      window.__EPOXY_KIT_STATE__.epoxyColor = colorKey;
      console.log('🎨 Epoxy color selected:', colorKey);
    });
  }

  setTimeout(initEpoxySwatchListener, 300);

  /* =====================================
     STEP 6B – FLAKE COLOR (SINGLE SELECT)
  ===================================== */

  function initFlakeSingleSelect() {
    const flakeInputs = document.querySelectorAll(
      '.flake-options input[name="flake"]'
    );
    if (!flakeInputs.length) {
      console.warn('Flake inputs not found');
      return;
    }

    flakeInputs.forEach(input => {
      input.addEventListener('change', function () {
        if (!this.checked) return;

        flakeInputs.forEach(other => {
          if (other !== this) other.checked = false;
        });

        const flakeName = this.dataset.name || this.value;
        if (flakeName) {
          const flakeKey = normalizeColor(flakeName);
          if (CONFIG.flakes[flakeKey]) {
            window.__EPOXY_KIT_STATE__.flake = flakeKey;
            console.log('🪨 Flake selected:', flakeKey);
          }
        }
      });
    });

    console.log('✅ Flake single-select enabled');
  }

  setTimeout(initFlakeSingleSelect, 300);

  /* =====================================
     STEP 7 – UPGRADE QTY TABLE
  ===================================== */

  const UPGRADE_QTY_BY_SQFT = [
    { max:  400, wb:  2, premera:  1, mvr:  1, easymvb:  2, hiwear:  1, anti:  1 },
    { max:  600, wb:  3, premera:  2, mvr:  2, easymvb:  2, hiwear:  2, anti:  1 },
    { max:  800, wb:  4, premera:  2, mvr:  2, easymvb:  3, hiwear:  2, anti:  1 },
    { max: 1000, wb:  5, premera:  3, mvr:  3, easymvb:  4, hiwear:  3, anti:  2 },
    { max: 1200, wb:  6, premera:  3, mvr:  3, easymvb:  5, hiwear:  3, anti:  2 },
    { max: 1400, wb:  7, premera:  4, mvr:  3, easymvb:  6, hiwear:  3, anti:  2 },
    { max: 1600, wb:  8, premera:  4, mvr:  4, easymvb:  6, hiwear:  4, anti:  2 },
    { max: 1800, wb:  9, premera:  5, mvr:  4, easymvb:  7, hiwear:  4, anti:  2 },
    { max: 2000, wb: 10, premera:  5, mvr:  5, easymvb:  8, hiwear:  5, anti:  3 },
    { max: 2200, wb: 11, premera:  6, mvr:  5, easymvb:  9, hiwear:  5, anti:  3 },
    { max: 2400, wb: 12, premera:  6, mvr:  5, easymvb: 10, hiwear:  5, anti:  3 },
    { max: 2600, wb: 13, premera:  7, mvr:  6, easymvb: 10, hiwear:  6, anti:  3 },
    { max: 2800, wb: 14, premera:  7, mvr:  6, easymvb: 11, hiwear:  6, anti:  3 },
    { max: 3000, wb: 15, premera:  8, mvr:  7, easymvb: 12, hiwear:  7, anti:  4 },
    { max: 3200, wb: 16, premera:  8, mvr:  7, easymvb: 13, hiwear:  7, anti:  4 },
    { max: 3400, wb: 17, premera:  9, mvr:  8, easymvb: 14, hiwear:  8, anti:  4 },
    { max: 3600, wb: 18, premera:  9, mvr:  8, easymvb: 14, hiwear:  8, anti:  4 },
    { max: 3800, wb: 19, premera: 10, mvr:  8, easymvb: 15, hiwear:  9, anti:  4 },
    { max: 4000, wb: 20, premera: 10, mvr: 10, easymvb: 16, hiwear:  9, anti:  5 },
    { max: 4200, wb: 21, premera: 11, mvr: 10, easymvb: 17, hiwear:  9, anti:  5 },
    { max: 4400, wb: 22, premera: 11, mvr: 10, easymvb: 18, hiwear: 10, anti:  5 },
    { max: 4600, wb: 23, premera: 12, mvr: 10, easymvb: 18, hiwear: 10, anti:  5 },
    { max: 4800, wb: 24, premera: 12, mvr: 11, easymvb: 19, hiwear: 11, anti:  5 },
    { max: 5000, wb: 25, premera: 13, mvr: 11, easymvb: 20, hiwear: 11, anti:  6 },
    { max: 5200, wb: 26, premera: 13, mvr: 12, easymvb: 21, hiwear: 12, anti:  6 },
    { max: 5400, wb: 27, premera: 14, mvr: 12, easymvb: 22, hiwear: 12, anti:  6 },
    { max: 5600, wb: 28, premera: 14, mvr: 12, easymvb: 22, hiwear: 13, anti:  6 },
    { max: 5800, wb: 29, premera: 15, mvr: 13, easymvb: 23, hiwear: 13, anti:  6 },
    { max: 6000, wb: 30, premera: 15, mvr: 13, easymvb: 24, hiwear: 13, anti:  7 },
    { max: 6200, wb: 31, premera: 16, mvr: 14, easymvb: 25, hiwear: 14, anti:  7 },
    { max: 6400, wb: 32, premera: 16, mvr: 14, easymvb: 26, hiwear: 14, anti:  7 },
    { max: 6600, wb: 33, premera: 17, mvr: 15, easymvb: 26, hiwear: 15, anti:  7 },
    { max: 6800, wb: 34, premera: 17, mvr: 15, easymvb: 27, hiwear: 15, anti:  7 },
    { max: 7000, wb: 35, premera: 18, mvr: 15, easymvb: 28, hiwear: 16, anti:  8 },
    { max: 7200, wb: 36, premera: 18, mvr: 16, easymvb: 29, hiwear: 16, anti:  8 },
    { max: 7400, wb: 37, premera: 19, mvr: 16, easymvb: 30, hiwear: 17, anti:  8 },
    { max: 7600, wb: 38, premera: 19, mvr: 17, easymvb: 30, hiwear: 17, anti:  8 },
    { max: 7800, wb: 39, premera: 20, mvr: 17, easymvb: 31, hiwear: 17, anti:  8 },
    { max: 8000, wb: 40, premera: 20, mvr: 18, easymvb: 32, hiwear: 18, anti:  9 },
    { max: 8200, wb: 41, premera: 21, mvr: 18, easymvb: 33, hiwear: 18, anti:  9 },
    { max: 8400, wb: 42, premera: 21, mvr: 19, easymvb: 34, hiwear: 19, anti:  9 },
    { max: 8600, wb: 43, premera: 22, mvr: 19, easymvb: 34, hiwear: 19, anti:  9 },
    { max: 8800, wb: 44, premera: 22, mvr: 19, easymvb: 35, hiwear: 20, anti:  9 },
    { max: 9000, wb: 45, premera: 23, mvr: 20, easymvb: 36, hiwear: 20, anti: 10 },
    { max: 9200, wb: 46, premera: 23, mvr: 20, easymvb: 37, hiwear: 21, anti: 10 },
    { max: 9400, wb: 47, premera: 24, mvr: 21, easymvb: 38, hiwear: 21, anti: 10 },
    { max: 9600, wb: 48, premera: 24, mvr: 21, easymvb: 38, hiwear: 21, anti: 10 },
    { max: 9800, wb: 49, premera: 25, mvr: 22, easymvb: 39, hiwear: 22, anti: 10 },
    { max:10000, wb: 50, premera: 25, mvr: 22, easymvb: 40, hiwear: 22, anti: 10 }
  ];

  function getUpgradeQtyForSqft(key, sqftMax) {
    const row =
      UPGRADE_QTY_BY_SQFT.find(r => sqftMax <= r.max) ||
      UPGRADE_QTY_BY_SQFT[UPGRADE_QTY_BY_SQFT.length - 1];

    switch (key) {
      case 'wb_epoxy_primer':           return row.wb;
      case 'premera_fp_fusion_primer':  return row.premera;
      case 'moisture_vapor_barrier':    return row.mvr;
      case 'high_wear_urethane_finish': return row.hiwear;
      case 'fine_anti_slip':            return row.anti;
      case 'coarse_anti_slip':          return row.anti;
      case 'premera_easymvb':           return row.easymvb;
      case 'crack_and_joint_paste_small': return 1;
      default:                          return 1;
    }
  }

  /* =====================================
     STEP 7A – UPGRADE SELECTION
  ===================================== */

  function normalizeUpgradeKey(str) {
    return str
      .toLowerCase()
      .replace(/[^a-z]/g, '_')
      .replace(/_+/g, '_')
      .trim();
  }

  const PRIMER_UPGRADE_KEYS = [
    'wb_epoxy_primer',
    'premera_fp_fusion_primer',
    'moisture_vapor_barrier'
  ];

  function getUpgradeKeyFromButton(btn) {
    return normalizeUpgradeKey(btn.getAttribute('data-variant-title') || '');
  }

  function showFlakeEasyMVBError(show) {
    let msg = document.getElementById('flake-easymvb-error-msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.id = 'flake-easymvb-error-msg';
      msg.style.cssText = 'display:none;color:#c00;font-size:13px;margin-top:6px;padding:8px 12px;background:#fff0f0;border:1px solid #fcc;border-radius:6px;line-height:1.5;';
      msg.textContent = 'Premera EasyMVB can only be added alongside Premera Fusion Primer. Please select Premera Fusion Primer first.';
      const container = document.querySelector('.vb-grid-picker_Bq4dpD');
      if (container) container.after(msg);
    }
    msg.style.display = show ? 'block' : 'none';
  }

  function initUpgradeListener() {
    const container = document.querySelector('.vb-grid-picker_Bq4dpD');
    if (!container) return;

    container.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const btn = e.target.closest('.vb-pill');
      if (!btn || !container.contains(btn)) return;

      const title = btn.getAttribute('data-variant-title');
      if (!title) return;

      const key = normalizeUpgradeKey(title);
      if (!CONFIG.upgrades[key]) return;

      const price = parseFloat(btn.getAttribute('data-price')) / 100 || 0;
      const state = window.__EPOXY_KIT_STATE__;
      if (!state.upgrades) state.upgrades = {};

      if (state.upgrades[key]) {
        delete state.upgrades[key];
        btn.classList.remove('is-active');
        btn.setAttribute('aria-checked', 'false');

        // If deselecting Fusion Primer, also deselect EasyMVB
        if (key === 'premera_fp_fusion_primer') {
          const easyBtn = container.querySelector('.vb-pill[data-variant-title*="EasyMVB"], .vb-pill[data-variant-title*="easymvb"]');
          if (easyBtn) {
            easyBtn.classList.remove('is-active');
            easyBtn.setAttribute('aria-checked', 'false');
          }
          delete state.upgrades['premera_easymvb'];
          showFlakeEasyMVBError(false);
        }
      } else {
        // Block EasyMVB if Fusion Primer is not selected
        if (key === 'premera_easymvb') {
          if (!state.upgrades['premera_fp_fusion_primer']) {
            showFlakeEasyMVBError(true);
            return;
          }
        }

        if (PRIMER_UPGRADE_KEYS.includes(key)) {
          container.querySelectorAll('.vb-pill').forEach(pill => {
            const pillKey = getUpgradeKeyFromButton(pill);
            if (PRIMER_UPGRADE_KEYS.includes(pillKey)) {
              pill.classList.remove('is-active');
              pill.setAttribute('aria-checked', 'false');
              delete state.upgrades[pillKey];
            }
          });

          // If selecting Fusion Primer, hide the EasyMVB error
          if (key === 'premera_fp_fusion_primer') {
            showFlakeEasyMVBError(false);
          }

          // If switching away from Fusion Primer, deselect EasyMVB
          if (key !== 'premera_fp_fusion_primer') {
            const easyBtn = container.querySelector('.vb-pill[data-variant-title*="EasyMVB"], .vb-pill[data-variant-title*="easymvb"]');
            if (easyBtn) {
              easyBtn.classList.remove('is-active');
              easyBtn.setAttribute('aria-checked', 'false');
            }
            delete state.upgrades['premera_easymvb'];
            showFlakeEasyMVBError(false);
          }
        }

        state.upgrades[key] = {
          id: CONFIG.upgrades[key].id,
          price: price,
          type: CONFIG.upgrades[key].type
        };
        btn.classList.add('is-active');
        btn.setAttribute('aria-checked', 'true');
      }

      recalcTotal();
    });
  }

  setTimeout(initUpgradeListener, 300);

  /* =====================================
     STEP T1 – TOOL KIT
  ===================================== */

  function initToolKitListener() {
    const container = document.querySelector('.vb-grid-picker_a4Vwmb');
    if (!container) return;

    container.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const btn = e.target.closest('.vb-pill');
      if (!btn || !container.contains(btn)) return;

      const state = window.__EPOXY_KIT_STATE__;
      if (!state.sqft) {
        alert('Please select square footage first');
        return;
      }

      const variantId = parseInt(btn.dataset.variantId, 10);
      const price = parseFloat(btn.getAttribute('data-price')) / 100 || 0;

      state.toolkit = { id: variantId };
      state.toolkitPrice = price;

      container.querySelectorAll('.vb-pill').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      recalcTotal();
    });
  }

  setTimeout(initToolKitListener, 300);

  /* =====================================
     STEP X – ADD SELECTED TO CART (FINAL)
  ===================================== */

  function validateKitState() {
    const state = window.__EPOXY_KIT_STATE__ || {};

    const sqftInputEl = document.getElementById('kit-sqft-input');
    if (sqftInputEl !== null && !sqftInputEl.value.trim()) {
      alert('Please enter your floor size in square feet before adding to cart.');
      return false;
    }

    if (!state.sqft) {
      alert('Please select square footage');
      return false;
    }

    if (!state.epoxyColor) {
      const activeSwatch = document.querySelector(
        '.vb-swatches .vb-swatch.is-active, .vb-swatches .vb-swatch[aria-checked="true"]'
      );
      if (activeSwatch) {
        const label =
          activeSwatch.getAttribute('data-label') ||
          activeSwatch.getAttribute('aria-label');
        if (label) {
          state.epoxyColor = normalizeColor(label);
          console.log('🎨 Epoxy color auto-detected:', state.epoxyColor);
        }
      }
    }

    if (!state.epoxyColor) {
      alert('Please select epoxy color');
      return false;
    }

    if (!state.flake) {
      const checkedFlake = document.querySelector(
        '.flake-options input[name="flake"]:checked'
      );
      if (checkedFlake) {
        const flakeName = checkedFlake.dataset.name || checkedFlake.value;
        if (flakeName) {
          const flakeKey = normalizeColor(flakeName);
          if (CONFIG.flakes[flakeKey]) {
            state.flake = flakeKey;
            console.log('🪨 Flake auto-detected:', state.flake);
          }
        }
      }
    }

    if (!state.flake) {
      alert('Please select flake color');
      return false;
    }

    return true;
  }

  function getBundleVariantForSqft(maxSqft) {
    const limits = Object.keys(BUNDLE_VARIANTS).map(Number).sort((a, b) => a - b);
    return BUNDLE_VARIANTS[limits.find(limit => maxSqft <= limit)];
  }

  function safePush(items, item, label) {
    if (!item || !item.id || isNaN(item.id)) {
      console.error(`❌ Skipped invalid item (${label}):`, item);
      return;
    }
    if (!item.quantity || item.quantity < 1) {
      console.error(`❌ Skipped invalid quantity (${label}):`, item);
      return;
    }
    items.push(item);
  }

  async function addSelectedKitToCart() {
    if (!validateKitState()) return;

    const state = window.__EPOXY_KIT_STATE__;
    const BUNDLE_ID = `flake-epoxy-${state.sqft.max}-${Date.now()}`;
    const kit = getKitForSqft(state.sqft.max);

    if (!kit) {
      alert('Invalid square footage selection');
      return;
    }

    if (!state.poly) state.poly = 'clear';

    const items = [];

    // 1️⃣ Bundle parent (only priced item)
    const bundleVariantId = getBundleVariantForSqft(state.sqft.max);
    if (!bundleVariantId) {
      alert('Unable to determine bundle price for selected Sq Ft');
      return;
    }

    items.push({
      id: bundleVariantId,
      quantity: 1,
      properties: {
        _bundle_id:     BUNDLE_ID,
        _bundle_parent: BUNDLE_ID,
        _bundle_title:  'Full Flake Floor Kit',
        _sqft:          state.sqft.label
      }
    });

    // 2️⃣ Tool Kit
    const TOOLKIT_LABELS = {
      52106624631087: 'Tool Kit For Up To 400 Sq Ft',
      52106624663855: 'Tool Kit For 401–1200 Sq Ft',
      52106624696623: 'Tool Kit For 1201+ Sq Ft'
    };

    const toolkit = state.toolkit;
    if (toolkit && toolkit.id) {
      const toolkitId = String(toolkit.id);

      items.push({
        id: toolkit.id,
        quantity: 1,
        properties: {
          _bundle_id: BUNDLE_ID,
          _bundle_role: 'toolkit',
          _toolkit: 'true',
          _toolkit_label: TOOLKIT_LABELS[toolkit.id] || 'Tool Kit',
          _parent_toolkit_id: toolkitId
        }
      });

      items.push(...(TOOLKIT_CHILD_ITEMS[toolkitId] || []).map(child => ({
        id: Number(child.variantId),
        quantity: Number(child.quantity),
        properties: {
          _bundle_id: BUNDLE_ID,
          _toolkit_child: 'true',
          _bundle_role: 'toolkit-item',
          _toolkit_item_label: child.label,
          _parent_toolkit_id: toolkitId,
          Included: 'Tool Kit'
        }
      })));

      console.log('🧰 Tool Kit and included tools added to cart:', toolkit);
    }

    // 3️⃣ Upgrades (primers, hi-wear, anti-slip, crack paste)
    const upgrades = window.__EPOXY_KIT_STATE__.upgrades || {};
    Object.keys(upgrades).forEach(key => {
      const upgrade = upgrades[key];
      let qty = 1;

      if (upgrade.type === 'auto') qty = getUpgradeQtyForSqft(key, state.sqft.max);
      if (upgrade.type === 'manual') qty = upgrade.qty || 1;

      if (!upgrade.id || isNaN(upgrade.id)) {
        console.error('❌ Invalid upgrade ID for:', key, upgrade);
        return;
      }

      // Determine role for organizer classification
      const isPrimer = PRIMER_UPGRADE_KEYS.includes(key);
      const isTopcoat = key === 'high_wear_urethane_finish';

      items.push({
        id: upgrade.id,
        quantity: qty,
        properties: {
          _bundle_id:   BUNDLE_ID,
          _bundle_role: isPrimer ? 'primer' : isTopcoat ? 'topcoat' : 'upgrade',
          _upgrade:     key
        }
      });
      console.log(`🧩 Upgrade added: ${key} × ${qty}`);
    });

    // 4️⃣ Epoxy pigment (included)
    safePush(items, {
      id: CONFIG.epoxyColors[state.epoxyColor],
      quantity: kit.epoxy,
      properties: {
        _bundle_id:    BUNDLE_ID,
        _bundle_child: 'true',
        _bundle_role:  'epoxy-pigment',
        Included:      'Full Flake Floor Kit'
      }
    }, 'Epoxy Pigment');

    // 5️⃣ Flakes (included)
    const FLAKE_BOX_VARIANT =
      CONFIG.flakes[state.flake] &&
      CONFIG.flakes[state.flake][40];

    safePush(items, {
      id: FLAKE_BOX_VARIANT,
      quantity: kit.flake_boxes,
      properties: {
        _bundle_id:    BUNDLE_ID,
        _bundle_child: 'true',
        _bundle_role:  'flake',
        Included:      'Full Flake Floor Kit'
      }
    }, 'Flakes 40lb');

    // 6️⃣ Polyaspartic — gallon-based split logic (included)
    let remainingGallons = kit.poly_kits;
    const TWO_GAL_VARIANT = CONFIG.polyaspartic.clear[2];
    const ONE_GAL_VARIANT = CONFIG.polyaspartic.clear[1];
    const twoGalQty = Math.floor(remainingGallons / 2);
    remainingGallons = remainingGallons % 2;

    if (twoGalQty > 0) {
      safePush(items, {
        id: TWO_GAL_VARIANT,
        quantity: twoGalQty,
        properties: {
          _bundle_id:    BUNDLE_ID,
          _bundle_child: 'true',
          _bundle_role:  'poly',
          Included:      'Full Flake Floor Kit'
        }
      }, 'Polyaspartic 2-Gal');
    }

    if (remainingGallons > 0) {
      safePush(items, {
        id: ONE_GAL_VARIANT,
        quantity: remainingGallons,
        properties: {
          _bundle_id:    BUNDLE_ID,
          _bundle_child: 'true',
          _bundle_role:  'poly',
          Included:      'Full Flake Floor Kit'
        }
      }, 'Polyaspartic 1-Gal');
    }

    console.log('🛒 Adding kit to cart:', items);
    console.log('🚨 FINAL CART PAYLOAD:', JSON.stringify(items, null, 2));

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });

    // Toolkit children are already included in the cart request above.

    window.location.href = '/cart';
  }

  function initAddSelectedToCart() {
    const btn = document.querySelector('.vb-add-btn');
    if (!btn) {
      console.warn('Add Selected to Cart button not found');
      return;
    }

    // Clone to strip all existing handlers (Variant Builder's included)
    const newBtn = btn.cloneNode(true);
    btn.parentNode.replaceChild(newBtn, btn);
    newBtn.type = 'button';

    newBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      addSelectedKitToCart();
    });

    console.log('✅ Full Flake cart logic active');
  }

  setTimeout(initAddSelectedToCart, 300);

  /* =====================================
     CART PAGE — LOCK ITEMS
  ===================================== */

  function lockKitItemsInCart() {
    if (!document.body.classList.contains('template-cart')) return;

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        cart.items.forEach(item => {
          if (!item.properties) return;

          const key = item.key.replace(/:/g, '\\:');
          const row = document
            .querySelector(`[name="updates[${key}]"]`)
            ?.closest('.cart__item');

          if (
            !item.properties._bundle_id &&
            item.product_title &&
            (
              item.product_title.toLowerCase().includes('base color') ||
              item.product_title.toLowerCase().includes('floor size')
            )
          ) {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: 0 })
            });
            return;
          }

          if (!row) return;

          if (item.properties._bundle_child === 'true') {
            row.style.display = 'none';
            row.querySelectorAll('input, button, a, select').forEach(el => {
              el.disabled = true;
              el.style.pointerEvents = 'none';
            });
            return;
          }

          if (
            item.properties._bundle_parent === item.properties._bundle_id &&
            !item.properties._bundle_child
          ) {
            row.querySelectorAll('.cart__trash, .cart__remove').forEach(btn => {
              btn.style.display = '';
              btn.style.pointerEvents = 'auto';
              btn.style.opacity = '1';
            });
          }
        });
      });
  }

  document.addEventListener('DOMContentLoaded', lockKitItemsInCart);
  document.addEventListener('booster:content:update', lockKitItemsInCart);

  function lockAutoUpgradeQtyInCart() {
    const AUTO_UPGRADES = [
      'wb_epoxy_primer',
      'premera_fp_fusion_primer',
      'moisture_vapor_barrier',
      'high_wear_urethane_finish',
      'fine_anti_slip',
      'coarse_anti_slip',
      'premera_easymvb'
    ];

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        cart.items.forEach(item => {
          if (!item.properties || !item.properties._upgrade) return;
          if (!AUTO_UPGRADES.includes(item.properties._upgrade)) return;

          const key = item.key.replace(/:/g, '\\:');
          const row =
            document.querySelector(`[name="updates[${key}]"]`)
              ?.closest('.cart__item');
          if (!row) return;

          row.querySelectorAll('input[type="number"], .quantity--input__button').forEach(el => {
            el.disabled = true;
            el.style.pointerEvents = 'none';
            el.style.opacity = '0.5';
          });

          row.querySelectorAll('.cart__trash, .cart__remove').forEach(btn => {
            btn.style.display = '';
            btn.style.pointerEvents = 'auto';
            btn.style.opacity = '1';
          });
        });
      });
  }

  document.addEventListener('DOMContentLoaded', lockAutoUpgradeQtyInCart);
  document.addEventListener('booster:content:update', lockAutoUpgradeQtyInCart);
  setTimeout(lockAutoUpgradeQtyInCart, 300);
  setTimeout(lockAutoUpgradeQtyInCart, 800);

  /* =====================================
     BUNDLE REMOVAL
  ===================================== */

  function forceRemoveBundle(bundleId) {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const updates = {};
        cart.items.forEach(item => {
          if (item.properties && item.properties._bundle_id === bundleId) {
            updates[item.key] = 0;
          }
        });
        if (!Object.keys(updates).length) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
      })
      .then(() => { window.location.reload(); });
  }

  function handleSideCartBundleRemoval() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const bundles = {};
        cart.items.forEach(item => {
          if (item.properties && item.properties._bundle_id) {
            if (!bundles[item.properties._bundle_id]) {
              bundles[item.properties._bundle_id] = [];
            }
            bundles[item.properties._bundle_id].push(item);
          }
        });

        Object.keys(bundles).forEach(bundleId => {
          if (!bundleId.startsWith('flake-epoxy-')) return;

          const items = bundles[bundleId];
          const parent = items.find(
            i => i.properties._bundle_parent === bundleId && !i.properties._bundle_child
          );

          if (!parent) {
            const updates = {};
            items.forEach(i => (updates[i.key] = 0));
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates })
            });
          }
        });
      });
  }

  document.addEventListener('booster:content:update', handleSideCartBundleRemoval);
  document.addEventListener('DOMContentLoaded', handleSideCartBundleRemoval);

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[onclick*="toggleBundle"]').forEach(el => {
      const match = el.getAttribute('onclick')?.match(/'([^']+)'/);
      if (!match) return;

      const bundleId = match[1];
      const container = el.closest('.cart__info');
      if (!container) return;
      if (container.querySelector('.bundle-remove-btn')) return;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bundle-remove-btn';
      btn.textContent = 'Remove bundle';
      btn.style.marginTop = '8px';
      btn.style.background = 'none';
      btn.style.border = 'none';
      btn.style.color = '#c00';
      btn.style.cursor = 'pointer';
      btn.style.fontWeight = '600';
      btn.addEventListener('click', () => { forceRemoveBundle(bundleId); });
      container.appendChild(btn);
    });
  });

  /* =====================================
     CART PAGE — TITLES & CLEANUP
  ===================================== */

  function fixBundleTitles() {
    document.querySelectorAll('.cart__bundle-toggle').forEach(toggle => {
      const titleEl = toggle.querySelector('.cart__bundle-title');
      if (!titleEl) return;

      const cartItem = toggle.closest('.cart__item');
      if (!cartItem) return;

      const isFlakeBundle =
        cartItem.innerText.includes('Full Flake Floor') ||
        cartItem.innerText.includes('Included: Full Flake Floor Kit') ||
        cartItem.innerText.includes('flake-epoxy-');

      if (!isFlakeBundle) return;

      const bundleInfo = toggle
        .closest('.cart__info--text')
        ?.querySelector('.cart__bundle-summary');
      if (!bundleInfo) return;

      const sqftLine = [...bundleInfo.querySelectorAll('li')]
        .find(li => li.textContent.includes('SQFT'));
      if (!sqftLine) return;

      const sqftMatch = sqftLine.textContent.match(/(\d+\s*-\s*\d+\s*SQFT)/i);
      if (!sqftMatch) return;

      titleEl.textContent = `Full Flake Floor Kit – ${sqftMatch[1]}`;
    });
  }

  document.addEventListener('DOMContentLoaded', fixBundleTitles);
  document.addEventListener('booster:content:update', fixBundleTitles);
  setTimeout(fixBundleTitles, 500);
  setTimeout(fixBundleTitles, 1200);

  function fixFlakeToolkitLabels() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        cart.items.forEach(item => {
          if (!item.properties || !item.properties._toolkit_label) return;
          if (!item.properties._bundle_id || !item.properties._bundle_id.startsWith('flake-epoxy-')) return;

          const label = item.properties._toolkit_label;
          const key = item.key.replace(/:/g, '\\:');

          // Main cart page — find the row by key and update its title element
          const row = document.querySelector(`[data-item-key="${item.key}"], [name="updates[${key}]"]`)
            ?.closest('.cart__item, .bkt-item, [data-bundle-id]');

          if (row) {
            const titleEl = row.querySelector('.cart__info--text a, .cart__info--text span, .bkt-item-title');
            if (titleEl && !titleEl.textContent.includes('Sq Ft')) {
              titleEl.textContent = label;
            }
          }

          // Bundle summary chips (bkt-item lines)
          document.querySelectorAll(`.bkt-item`).forEach(el => {
            const text = el.textContent || '';
            if (
              (text.includes('Full Flake') && text.includes('Tool Kit')) ||
              (text.includes('Tool Kits For Flake'))
            ) {
              el.textContent = `${label} × 1`;
            }
          });

          // Section headings (sidecart or cart page toolkit label)
          document.querySelectorAll('.bkt-section-heading, .bkt-heading-row span').forEach(el => {
            if (el.textContent.includes('Tool Kits For Flake') || el.textContent === 'Tool Kit') {
              el.textContent = label;
            }
          });
        });
      });
  }

  document.addEventListener('DOMContentLoaded', fixFlakeToolkitLabels);
  document.addEventListener('booster:content:update', fixFlakeToolkitLabels);
  setTimeout(fixFlakeToolkitLabels, 400);
  setTimeout(fixFlakeToolkitLabels, 1000);
  
  function hideBundleSelfLine() {
    document.querySelectorAll('.cart__bundle-summary-line').forEach(line => {
      if (line.textContent.includes('Full Flake Floor')) {
        line.style.display = 'none';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', hideBundleSelfLine);
  document.addEventListener('booster:content:update', hideBundleSelfLine);
  setTimeout(hideBundleSelfLine, 300);

  /* =====================================
     BUILDER PAGE — RECALC TOTAL
  ===================================== */

  function updateVBTotal(amount) {
    const totalEl = document.querySelector('.vb-total-amount');
    if (!totalEl) return;
    totalEl.textContent = `US$${amount.toFixed(2)}`;
  }

  function recalcTotal() {
    const state = window.__EPOXY_KIT_STATE__;
    let total = 0;

    total += state.sqftPrice || 0;
    total += state.toolkitPrice || 0;

    Object.entries(state.upgrades || {}).forEach(([key, upgrade]) => {
      let qty = 1;
      if (upgrade.type === 'auto' && state.sqft) qty = getUpgradeQtyForSqft(key, state.sqft.max);
      if (upgrade.type === 'manual') qty = upgrade.qty || 1;
      total += (upgrade.price || 0) * qty;
    });

    updateVBTotal(total);
  }


  // =====================================
// SQFT NUMBER INPUT (replaces collapsible pill grid)
// =====================================
(function initSqftInput() {
  function setup() {
    const container = document.querySelector('.vb-grid-picker_9CJjMy');
    if (!container) return;

    const block = container.closest('.vb-block');
    if (!block || block.dataset.sqftInputReady) return;
    block.dataset.sqftInputReady = '1';

    const grid = container;

    // Keep pills in DOM for programmatic selection — just hide visually
    grid.style.setProperty('display', 'none', 'important');

    // Hide original block head
    const head = block.querySelector('.vb-block-head');
    if (head) head.style.display = 'none';

    // ── Build input UI ──
    const wrapper = document.createElement('div');
    wrapper.className = 'kit-sqft-input-wrap';
    wrapper.innerHTML = `
      <div class="kit-sqft-input-label">Step 2 \u2013 Enter Your Floor Size</div>
      <div class="kit-sqft-input-row">
        <input
          type="number"
          id="kit-sqft-input"
          class="kit-sqft-input"
          placeholder="e.g. 500"
          min="1"
          max="10000"
          autocomplete="off"
          style="width: 132px;"
        />
        <span class="kit-sqft-input-unit">sq ft</span>
      </div>
      <div id="kit-sqft-feedback" class="kit-sqft-feedback"></div>
    `;
    block.insertBefore(wrapper, grid);

    // ── Styles ──
    if (!document.getElementById('kit-sqft-input-style')) {
      const style = document.createElement('style');
      style.id = 'kit-sqft-input-style';
      style.textContent = `
        .kit-sqft-input-wrap {
          padding: 10px 0 20px;
        }
        .kit-sqft-input-label {
          font-weight: 700;
          font-size: 20px;
          font-family: 'Nunito', sans-serif;
          margin-bottom: 12px;
        }
        .kit-sqft-input-row {
          display: flex;
          align-items: center;
          gap: 10px;
          max-width: 280px;
        }
        .kit-sqft-input {
          flex: 1;
          padding: 10px 14px;
          font-size: 16px;
          border: 2px solid #d1d5db;
          border-radius: 8px;
          outline: none;
          font-family: inherit;
          transition: border-color 0.2s;
          -moz-appearance: textfield;
        }
        .kit-sqft-input::-webkit-outer-spin-button,
        .kit-sqft-input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        .kit-sqft-input:focus {
          border-color: #097CFF;
          box-shadow: 0 0 0 3px rgba(9,124,255,0.12);
        }
        .kit-sqft-input-unit {
          font-size: 15px;
          color: #555;
          font-weight: 600;
          white-space: nowrap;
        }
        .kit-sqft-feedback {
          margin-top: 8px;
          font-size: 14px;
          min-height: 20px;
          font-weight: 500;
          line-height: 1.4;
        }
        .kit-sqft-feedback.success { color: #097CFF; }
        .kit-sqft-feedback.error   { color: #c00; }
        @media (min-width: 768px) {
          .kit-sqft-input-wrap {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            gap: 0 20px;
          }
          .kit-sqft-input-label {
            margin-bottom: 0;
            white-space: nowrap;
            flex-shrink: 0;
          }
          .kit-sqft-input-row {
            flex-shrink: 0;
          }
          #kit-sqft-feedback {
            width: 100%;
          }
        }
        .vb-block-title .vb-required {
          display: none !important;
        }
      `;
      document.head.appendChild(style);
    }

    // ── Find the correct pill for an entered sqft value ──
    // Full flake ranges go up to 10,000 in steps of 200
    function findPillForSqft(sqft) {
      const pills = Array.from(grid.querySelectorAll('.vb-pill'));
      const scored = pills
        .map(function(pill) {
          const title = pill.getAttribute('data-variant-title') || '';
          if (!title.toLowerCase().includes('sqft')) return null;
          const range = parseSqftRange(title);
          return range ? { pill: pill, max: range.max } : null;
        })
        .filter(Boolean)
        .sort(function(a, b) { return a.max - b.max; });

      const match = scored.find(function(item) { return sqft <= item.max; });
      return match ? match.pill : (scored.length ? scored[scored.length - 1].pill : null);
    }

    // ── Apply pill selection and update all state ──
    function applyPillSelection(pill) {
      grid.querySelectorAll('.vb-pill').forEach(function(p) {
        p.classList.remove('is-active');
        p.setAttribute('aria-checked', 'false');
      });
      pill.classList.add('is-active');
      pill.setAttribute('aria-checked', 'true');

      const title = pill.getAttribute('data-variant-title') || '';
      const range = parseSqftRange(title);
      const cents = Number(pill.getAttribute('data-price') || 0);

      window.__EPOXY_KIT_STATE__.sqft = {
        label: title.trim(),
        min:   range ? range.min : 0,
        max:   range ? range.max : 0
      };
      window.__EPOXY_KIT_STATE__.sqftPrice = cents / 100;
      // Reset toolkit when sqft changes
      window.__EPOXY_KIT_STATE__.toolkit = null;
      window.__EPOXY_KIT_STATE__.toolkitPrice = 0;

      recalcTotal();
    }

    // ── Auto-select lowest range immediately so pricing shows on load ──
    var firstPill = grid.querySelector('.vb-pill');
    if (firstPill && !firstPill.classList.contains('is-active')) {
      applyPillSelection(firstPill);
    }

    // ── Input handler with debounce ──
    const input    = document.getElementById('kit-sqft-input');
    const feedback = document.getElementById('kit-sqft-feedback');
    let   _debounce = null;

    input.addEventListener('keydown', function(e) {
      if (['e', 'E', '+', '-', '.'].includes(e.key)) {
        e.preventDefault();
      }
    });

    input.addEventListener('input', function() {
      clearTimeout(_debounce);
      _debounce = setTimeout(function() {
        const raw = parseInt(input.value, 10);

        feedback.className = 'kit-sqft-feedback';
        feedback.textContent = '';

        if (!input.value.trim() || isNaN(raw)) {
          window.__EPOXY_KIT_STATE__.sqft = null;
          window.__EPOXY_KIT_STATE__.sqftPrice = 0;
          recalcTotal();
          return;
        }

        if (raw < 1) {
          feedback.className = 'kit-sqft-feedback error';
          feedback.textContent = 'Please enter a valid square footage greater than 0.';
          return;
        }

        if (raw > 10000) {
          feedback.className = 'kit-sqft-feedback error';
          feedback.textContent = 'Maximum supported size is 10,000 sq ft. Please contact us for larger projects.';
          return;
        }

        const pill = findPillForSqft(raw);

        if (!pill) {
          feedback.className = 'kit-sqft-feedback error';
          feedback.textContent = 'Could not match a range. Please try a different value.';
          return;
        }

        applyPillSelection(pill);

        const rangeTitle = pill.getAttribute('data-variant-title') || '';
        feedback.className = 'kit-sqft-feedback success';
        feedback.textContent = '\u2713 Kit sized for: ' + rangeTitle;

      }, 400);
    });
  }

  setTimeout(setup, 300);
  setTimeout(setup, 800);
  document.addEventListener('DOMContentLoaded', setup);
})();

  /* =====================================
     BUILDER PAGE — PRICE LABELS
  ===================================== */
  
  document.addEventListener('DOMContentLoaded', function () {
    const PER_GAL = ['WB Epoxy Primer', 'Premera FP1 Fusion Primer'];
    const PER_SET = ['Moisture Vapor Barrier', 'High Wear Urethane Finish', 'Fine Anti Slip', 'Coarse Anti Slip', 'Premera EasyMVB'];

    document.querySelectorAll('.vb-pill').forEach(pill => {
      const title = pill.getAttribute('data-variant-title');
      const priceEl = pill.querySelector('.vb-pill-sub');
      if (!priceEl || !title) return;

      if (PER_GAL.includes(title) && !priceEl.textContent.toLowerCase().includes('per gal')) {
        priceEl.textContent += ' per gal';
      }
      if (PER_SET.includes(title) && !priceEl.textContent.toLowerCase().includes('per set')) {
        priceEl.textContent += ' per set';
      }
    });
  });

  // TABLET LAYOUT — FLAKES 8 COLUMNS, SWATCHES 3 COLUMNS
(function injectTabletStyles() {
  const style = document.createElement('style');
  style.textContent = `
    @media (min-width: 768px) and (max-width: 1024px) {

      /* Flake options - 8 per row */
    .section-template--25629375693103__variant_cULthA .flake-options, #shopify-section-template--25629375693103__flake_selector_cVVjNt .flake-options {
        grid-template-columns: repeat(8, 1fr) !important;
    }

      /* Color swatches - 3 per row */
    .vb-swatches {
      display: grid !important;
      grid-template-columns: repeat(3, 1fr) !important;
    }

      /* Button - wide enough for single line text */
    #b--button_LaNQdP {
      width: auto !important;
       max-width: 100% !important;
    }

    #button--button_LaNQdP {
     white-space: nowrap !important;
     width: auto !important;
     padding-left: 24px !important;
     padding-right: 24px !important;
    }

    }
  `;
  document.head.appendChild(style);
})(); 
  /* =====================================
     BUILDER PAGE — FAQ
  ===================================== */

  document.querySelectorAll('.faq-question').forEach(question => {
    question.addEventListener('click', () => {
      const answer = question.nextElementSibling;
      const icon = question.querySelector('.faq-icon');
      const isOpen = answer.style.maxHeight;

      document.querySelectorAll('.faq-answer').forEach(a => a.style.maxHeight = null);
      document.querySelectorAll('.faq-icon').forEach(i => i.style.transform = 'rotate(0deg)');
      document.querySelectorAll('.faq-question').forEach(q => q.classList.remove('active'));

      if (!isOpen) {
        answer.style.maxHeight = answer.scrollHeight + 'px';
        icon.style.transform = 'rotate(180deg)';
        question.classList.add('active');
      }
    });
  });

  /* =====================================
     BUILDER PAGE — UPGRADE TOOLTIPS
  ===================================== */

  (function () {
    const tooltips = {
      "52106625614127": "Seals the concrete and increases adhesion so your coatings bond properly. Recommended for stronger, longer lasting floors. Needed for wood substrate and porous or soft concrete.",
      "52110996177199": "Premera FP1 Fusion Primer eliminates concrete grinding. This cutting edge, fast drying spray on primer is designed to bond any resinous material seamlessly to nearly any smooth hard surface contaminate free surface.",
      "52084877361455": "A 100% solids epoxy made to block moisture from rising up through the concrete and delaminating the epoxy in high moisture areas such as basements and exterior surfaces.",
      "52084881326383": "For commercial kitchens, the recommended system is a moisture vapor barrier followed by epoxy, vinyl flakes, a polyaspartic seal coat, and a Hi Wear Urethane topcoat for maximum commercial durability.",
      "52084881359151": "Fast curing user friendly 100% solids epoxy paste for filling cracks, joints, chips, and divots on both horizontal and vertical surfaces. Medium gray in color.",
      "52084881293615": "Up to 1000 SF - Blends into the Polyaspartic topcoat to provide light added traction where a modest increase in slip resistance is wanted.",
      "52106624631087": "Save $75.92 On Tools Needed For Your Floor Installation\n\n• 2× 18\" Pro Performance Rollers\n• 1× 1/8\" Notched Squeegee\n• 1× Heavy-Duty Roller Frame\n• 1× 5-Gallon Helix Mixer\n• 1× Flat Squeegee\n• 1× Spiked Shoes\n• 2× 9\" High-Quality Rollers\n• 1× 9\" Roller Frame\n• 2× Chip Brushes\n• 1× Scraper\n• 1× Painter Pole\n\nValue: $355.91",
      "52106624663855": "Save $84.91 On Tools Needed For Your Floor Installation\n\n• 3× 18\" Pro Performance Rollers\n• 1× 1/8\" Notched Squeegee\n• 1× Heavy-Duty Roller Frame\n• 1× 5-Gallon Helix Mixer\n• 1× Flat Squeegee\n• 2× Spiked Shoes\n• 2× 9\" High-Quality Rollers\n• 1× 9\" Roller Frame\n• 2× Chip Brushes\n• 1× Scraper\n• 2× Painter Poles\n\nValue: $404.90",
      "52106624696623": "Save $122.87 On Tools Needed For Your Floor Installation\n\n• 6× 18\" Pro Performance Rollers\n• 1× 1/8\" Notched Squeegee\n• 2× 18\" Heavy-Duty Roller Frame\n• 1× Cage Mixer\n• 1× Flat Squeegee\n• 3× Spiked Shoes\n• 3× 9\" High-Quality Roller Covers\n• 1× 9\" Roller Frame\n• 6× Chip Brushes\n• 1× Scraper\n• 2× Painter Poles\n\nValue: $522.86",
      "53369387155759": "Fast curing user friendly 100% solids epoxy paste for filling cracks, joints, chips, and divots on both horizontal and vertical surfaces. Medium gray in color.",
      "53369488408879": "Fast curing user friendly 100% solids epoxy paste for filling cracks, joints, chips, and divots on horizontal surfaces. Sold white and can be pigmented.",
      "53369488441647": "2× 18\" Pro Performance Rollers\n• 1× 1/8\" Notched Squeegee\n• 2× Heavy-Duty Roller Frame\n• 1× 5-Gallon Cage Mixer\n• 2× Spiked Shoes\n• 2× 9\" High-Quality Rollers\n• 1× 9\" Roller Frame\n• 2× Chip Brushes",
      "53369387188527": "Up to 1000 SF – Blend or broadcast into the Polyaspartic topcoat to provide light added traction where a modest increase in added slip resistance is wanted.",
      "53369488507183": "Up to 500 SF – Blend or broadcast into the Polyaspartic topcoat to provide aggressive slip resistance. Makes mopping very difficult.",
      "56465291772207": "Fast curing user friendly 100% solids epoxy paste for filling cracks, joints, chips, and divots on horizontal surfaces. Sold white and can be pigmented.",
      "56465291804975": "Up to 500 SF – Blend or broadcast into the Polyaspartic topcoat to provide aggressive slip resistance. Makes mopping very difficult.",
      "56465291837743": "Penetrating moisture vapor barrier that soaks into concrete and seals it from within. Designed for use only with Premera Fusion Primer, EasyMVB blocks up to 25 lbs of moisture vapor transmission while sealing pores and capillaries inside the concrete. It helps reduce pinholes, blisters, and adhesion issues so your coating system bonds properly and performs as intended."
    };

    const box = document.createElement('div');
    box.id = 'vb-hover-tooltip';
    box.style.cssText = [
      'display:none', 'position:fixed', 'background:#097CFF', 'color:#fff',
      'padding:14px 18px', 'border-radius:10px', 'font-size:14px', 'line-height:1.6',
      'white-space:pre-wrap', 'z-index:99999', 'width:90vw', 'max-width:360px',
      'box-shadow:0 6px 24px rgba(0,0,0,0.3)', 'pointer-events:none', 'font-family:inherit'
    ].join(';');
    document.body.appendChild(box);

    const mobileBox = document.createElement('div');
    mobileBox.style.cssText = [
      'display:none', 'position:fixed', 'background:#097CFF', 'color:#fff',
      'padding:14px 18px', 'border-radius:10px', 'font-size:14px', 'line-height:1.6',
      'white-space:pre-wrap', 'z-index:99999', 'width:90vw', 'max-width:360px',
      'box-shadow:0 6px 24px rgba(0,0,0,0.3)', 'pointer-events:none', 'font-family:inherit'
    ].join(';');
    document.body.appendChild(mobileBox);

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') mobileBox.style.display = 'none';
    });
    document.addEventListener('click', e => {
      if (!e.target.closest('.vb-grid-picker_Bq4dpD, .vb-grid-picker_a4Vwmb')) {
        mobileBox.style.display = 'none';
      }
    });

    const isTouch = () => navigator.maxTouchPoints > 0 || 'ontouchstart' in window;

    function showDesktopTooltip(text, btn) {
      box.textContent = text;
      box.style.display = 'block';
      const r = btn.getBoundingClientRect();
      let left = r.left + r.width / 2 - 180;
      left = Math.max(10, Math.min(left, window.innerWidth - 370));
      box.style.left = left + 'px';
      box.style.top = (r.bottom + 8) + 'px';
    }

    function showMobileTooltip(text, btn) {
      mobileBox.textContent = text;
      // Move to body so it's never clipped by a column container
      if (mobileBox.parentElement !== document.body) {
        document.body.appendChild(mobileBox);
      }
      const w = Math.min(340, window.innerWidth - 24);
      const r = btn.getBoundingClientRect();
      // position:absolute relative to document so it scrolls with the page
      mobileBox.style.position = 'absolute';
      mobileBox.style.width = w + 'px';
      mobileBox.style.left = Math.round((window.innerWidth - w) / 2) + 'px';
      mobileBox.style.top = (window.scrollY + r.bottom + 10) + 'px';
      mobileBox.style.display = 'block';
    }

    function attachTooltips() {
      const selector = '.vb-grid-picker_Bq4dpD button.lazyElement.vb-pill, .vb-grid-picker_a4Vwmb button.lazyElement.vb-pill';
      document.querySelectorAll(selector).forEach(function (btn) {
        const id = btn.getAttribute('data-variant-id');
        if (!id || !tooltips[id]) return;
        if (btn.dataset.vbTooltipReady) return;
        btn.dataset.vbTooltipReady = '1';

        if (!btn.querySelector('.vb-info-icon')) {
          const icon = document.createElement('span');
          icon.className = 'vb-info-icon';
          icon.textContent = ' ⓘ';
          icon.style.cssText = 'font-size:14px;cursor:help;pointer-events:none;';
          btn.appendChild(icon);
        }

        btn.addEventListener('mouseenter', function () {
          if (isTouch()) return;
          showDesktopTooltip(tooltips[id], btn);
        });
        btn.addEventListener('mouseleave', function () {
          if (isTouch()) return;
          box.style.display = 'none';
        });
        if (isTouch()) {
          btn.addEventListener('click', function () {
            showMobileTooltip(tooltips[id], btn);
          });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attachTooltips);
    } else {
      attachTooltips();
    }

    const observer = new MutationObserver(attachTooltips);
    observer.observe(document.body, { childList: true, subtree: true });
  })();

  // =====================================
// SCROLL TO TOP BUTTON
// =====================================
(function initScrollToTop() {
  if (document.getElementById('kit-scroll-top-btn')) return;

  const style = document.createElement('style');
  style.textContent = `
    #kit-scroll-top-btn {
      position: fixed;
      bottom: 100px;
      right: 100px;
      width: 35px;
      height: 35px;
      border-radius: 50%;
      background: #00008C;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.25s ease;
      box-shadow: 0 3px 10px rgba(0,0,0,0.25);
    }
    #kit-scroll-top-btn.is-visible {
      opacity: 1;
      pointer-events: auto;
    }
    #kit-scroll-top-btn svg {
      display: block;
    }
    @media (max-width: 1024px) {
      #kit-scroll-top-btn {
        bottom: 70px;
        right: 70px;
      }
    }
    @media (max-width: 600px) {
      #kit-scroll-top-btn {
        bottom: 30px;
        right: 30px;
        width: 26px;
        height: 26px;
      }
    }
  `;
  document.head.appendChild(style);

  const btn = document.createElement('button');
  btn.id = 'kit-scroll-top-btn';
  btn.setAttribute('aria-label', 'Scroll to top');
  btn.innerHTML = `<svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2 10L7 4L12 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`;
  document.body.appendChild(btn);

  window.addEventListener('scroll', function () {
    btn.classList.toggle('is-visible', window.scrollY > 300);
  }, { passive: true });

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();



})();